module.exports = __webpack_public_path__ + "static/media/twitterActive.698d145d.png";